import React from "react";
import { OBJECTIVE_TYPE } from "../../_config/quarterlyOkrConfig";
import ReviewObjectiveRow from "../ReviewObjectiveRow/ReviewObjectiveRow";

// "Company OKRs" tab (§9.3): the CEO's company objectives, one row each.
const ReviewCompanyOkrs = ({ review, rowProps }) => {
  const objectives = review.company_objectives || [];
  if (!objectives.length) {
    return <div className="aokr-empty">No company objectives.</div>;
  }
  return (
    <div className="rm-rows">
      {objectives.map((objective) => (
        <ReviewObjectiveRow
          key={objective.objective_id}
          {...rowProps(OBJECTIVE_TYPE.COMPANY, objective)}
        />
      ))}
    </div>
  );
};

export default ReviewCompanyOkrs;
